import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { ColorEnum } from '../../../../models/enums/color.enum';

@Component({
  selector: 'jhi-bary-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bary-badge.component.html',
  imports: [MDBBootstrapModulesPro, TranslateModule, NgIf, NgClass, BaryIconComponent],
  styleUrls: ['./bary-badge.component.scss'],
})
export class BaryBadgeComponent {
  @Input() public options!: {
    label?: string;
    labelKey?: string;
    color?: ColorEnum;
    emoji?: string;
    icon?: string;
    tooltipKey?: string;
    iconTooltipKey?: string;
    iconTooltipParams?: any;
  };

  @Input() public pill: boolean = true;

  public readonly colorEnum = ColorEnum;

  protected readonly FAS = FaDirectiveEnum.FAS;
}
